<style lang="less" type="text/less" scoped>

</style>
<template>
    <div>
        test
        <button @click="$router.go('/index')">index</button>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {}
        },
        computed: {},
        methods: {},
        components: {},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// test.vue?b49d7b14